import { Directive, ElementRef, HostListener } from '@angular/core';

@Directive({
  selector: '[appDefaultAvatarCustomerIfError]',
})
export class DefaultAvatarCustomerIfErrorDirective {
  hasSetDefaultAvatar = false;

  constructor(private elRef: ElementRef) {}

  @HostListener('error') onError() {
    if (!this.hasSetDefaultAvatar) {
      // prevent infinite requests if the default avatar triggers an error
      this.elRef.nativeElement.setAttribute('src', 'assets/img/default-avatar-customer.png');
      this.hasSetDefaultAvatar = true;
    }
  }
}
